module.exports = __webpack_public_path__ + "static/media/4909c782-2e3d-4c1c-ae03-87f51e4f8716.744785fd.jpg";